module.exports = __webpack_public_path__ + "media/test.e1b4eaf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/test.png
// module id = 677
// module chunks = 2